import PropTypes from 'prop-types';

import {
  ICON_BEFORE_POSITION,
  ICON_AFTER_POSITION
} from '../constants';

export default PropTypes.oneOf([ICON_BEFORE_POSITION, ICON_AFTER_POSITION]);
